module.exports = __webpack_public_path__ + "static/media/Phone-gray.9a647535.svg";